export default __webpack_public_path__ + "static/39-fe99cffd5bad93a352bed0dade546bee.jpg";